import { Box, Button, IconButton, TextField, Typography } from "@mui/material";
import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import CloseIcon from "./components/icons/CloseIcon";

// http://127.0.0.1:5000/register for testing locally
// https://blooming-hamlet-96520-b99bb79f6f22.herokuapp.com/register for hosting online

const backendUrl = process.env.REACT_APP_API_URL;
console.log("Backend URL:", backendUrl); // Debugging

const Register = ({ onClose }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [authMessage, setAuthMessage] = useState("");

  const navigate = useNavigate();

  const handleRegister = async (event) => {
    event.preventDefault(); // ✅ Prevents page reload
    
    if (!email || !password) {
      setAuthMessage("All fields are required!");
      return;
    }
  
    console.log("🚀 Attempting to register with:", email, password); // ✅ Log before request
    try {
      const response = await axios.post(`${backendUrl}/register`, { email, password });

      console.log("✅ API Response:", response); // ✅ Log response
  
      if (response.status === 201) {
        setAuthMessage("Registration successful!");
        setTimeout(() => {
          console.log("🔄 Forcing redirect...");
          window.location.href = "/login"; // ✅ This guarantees the redirect
        }, 2000);
      } else {
        setAuthMessage(response.data.message || "Registration failed.");
      }
    } catch (error) {
      console.error("Registration failed:", error.response || error);
  
      // ✅ Properly Handle the "Email already exists" error
      if (error.response && error.response.status === 400) {
        setAuthMessage("❌ Email already exists. Please try again.");
        return; // ❗ Prevent further execution
      }
  
      // ✅ Handle any other errors
      setAuthMessage("An unexpected error occurred. Please try again.");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        bgcolor: "#fff",
        borderRadius: "32px",
        p: { xs: "50px 16px", md: "50px 24px" },
        maxWidth: "527px",
        width: "calc(100vw - 32px)",
        position: "relative",
      }}
    >
      <IconButton
        sx={{
          position: "absolute",
          top: "30px",
          right: "30px",
        }}
      >
        <CloseIcon onClick={onClose} />
      </IconButton>
      <Typography variant="h2" textAlign={"center"}>
        Sign Up
      </Typography>
      <Typography
        variant="body4"
        textAlign={"center"}
        color="#8B8B8B"
        mt={1.5}
        sx={{ textWrap: "balance" }}
      >
        Please fill in the form to create an account.
      </Typography>
      <Box mt={2} maxWidth={"400px"}>
        <form onSubmit={handleRegister}>
          <TextField
            type="email"
            label="Email"
            autoComplete="username"
            variant="outlined"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <TextField
            type="password"
            label="Password"
            autoComplete="new-password"
            variant="outlined"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
          <Button
            type="submit"
            variant="contained"
            color="default"
            size="large"
            fullWidth
            sx={{
              mt: 2,
            }}
          >
            Register
          </Button>
        </form>
      </Box>
      {authMessage && (
        <Typography color="error" sx={{ mt: 2 }}>
          {authMessage}
        </Typography>
      )}
      <Typography
        variant="body1"
        textAlign={"center"}
        mt={"32px"}
        color="#6C6C6C"
        sx={{ textWrap: "balance" }}
      >
        Already have an account?{" "}
        <Typography
          color="brand"
          component={"span"}
          sx={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={onClose}
        >
          Log in
        </Typography>
      </Typography>
    </Box>
  );
};

export default Register;
